import Bradesco from "~/assets/images/partnerships/bradesco.png";
import Cassi from "~/assets/images/partnerships/cassi.png";
import Inb from "~/assets/images/partnerships/inb.png";
import Mediservice from "~/assets/images/partnerships/mediservice.png";
import Petrobras from "~/assets/images/partnerships/petrobras.png";
import Sulamerica from "~/assets/images/partnerships/sulamerica.png";
import Unimed from "~/assets/images/partnerships/unimed.png";
import SaudeLeve from "~/assets/images/partnerships/saude-leve.png";
import Plamesc from "~/assets/images/partnerships/plamesc.png";
import AcelorMittal from "~/assets/images/partnerships/acelormittal.png";

export const dataPartnerships = [
  {
    id: 1,
    image: Bradesco,
    name: `Bradesco`,
  },
  {
    id: 2,
    image: Sulamerica,
    name: `Sul América`,
  },
  {
    id: 3,
    image: Unimed,
    name: `Unimed`,
  },
  {
    id: 4,
    image: Mediservice,
    name: `Mediservice`,
  },
  {
    id: 5,
    image: Petrobras,
    name: `Petrobras`,
  },
  {
    id: 6,
    image: Inb,
    name: `INB`,
  },
  {
    id: 7,
    image: Cassi,
    name: `Cassi`,
  },
  {
    id: 8,
    image: SaudeLeve,
    name: `Saúde Leve`,
  },
  {
    id: 9,
    image: Plamesc,
    name: `Plamesc`,
  },
  {
    id: 10,
    image: AcelorMittal,
    name: `AcelorMittal`,
  },
];
